import React, { useState, useEffect } from 'react';
import { API_PATHS } from '../../../utils/constants';
import axios from 'axios';
import { /* auth, */ getToken, getOrganizationCode } from '../../../services/auth'; // Import the auth service
import { getFormattedRequestId } from '../../../utils/requestNumberUtils';
import { parseDate } from '../../../utils/dateUtils';
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  InputAdornment,
  TextField,
  // Link, // Commented out - unused
  Alert
  // Snackbar // Commented out - unused
} from '@mui/material';
import {
  Add as AddIcon,
  Visibility as VisibilityIcon,
  // Person as PersonIcon, // Commented out - unused
  Search as SearchIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


// Status chip component
const StatusChip = ({ status }) => {
  let color = 'default';
  let label = status;
  // let icon = null; // Commented out - unused
  
  switch (status) {
    case 'CREATED':
      color = 'info';
      label = 'Created';
      break;
    case 'IN_PROGRESS':
      color = 'warning';
      label = 'In Progress';
      break;
    case 'COMPLETED':
      color = 'success';
      label = 'Completed';
      break;
    case 'CANCELLED':
      color = 'error';
      label = 'Cancelled';
      break;
    case 'PENDING':
      color = 'default';
      label = 'Pending';
      break;
    default:
      color = 'default';
      label = status || 'Unknown';
  }
  
  return (
    <Chip 
      label={label} 
      color={color} 
      size="small"
      sx={{
        minWidth: '90px',
        '& .MuiChip-label': {
          fontWeight: 500
        }
      }}
    />
  );
};

const WorkflowRequestList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [requests, setRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [targetTypeFilter, setTargetTypeFilter] = useState('ALL');
  const [organizationCode, setOrganizationCode] = useState('');
  const [error, setError] = useState('');
  const [infoMessage, setInfoMessage] = useState('');

  // Helper to parse fields JSON safely
  const parseFields = (fieldsJson) => {
    try {
      if (!fieldsJson) return {};
      return JSON.parse(fieldsJson);
    } catch (e) {
      console.error('Error parsing fields JSON:', e);
      return {};
    }
  };

  // Function to format numeric organization codes as 3-digit codes
  // Commented out to fix unused variable warning
  /* const formatOrganizationCode = (code) => {
    if (code && code.length < 3) {
      // Add leading zeros if needed
      return code.padStart(3, '0');
    }
    return code;
  }; */

  // Function to determine organization code based on user context
  // Currently unused but kept for future implementation
  /* const determineOrganizationCode = async (authToken) => {
    // Try to get organization code from the API
    try {
      const response = await axios.get(`${API_PATHS.API}/auth/me`, {
        headers: { 
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
        timeout: 5000
      });
      
      if (response && response.data) {
        console.log('User profile data:', response.data);
        
        // Check for name field that might contain organization code
        if (response.data.name) {
          // Special case for org-customer-3
          if (response.data.name.includes('org-customer-3') || 
              response.data.name.toLowerCase().includes('customer3')) {
            console.log('Detected org-customer-3, using code 003');
            return '003';
          }
          
          // Extract org code from names like "admin1-customer-org3"
          const match = response.data.name.match(/.*org(\w+)$/i);
          if (match && match[1]) {
            const extractedCode = match[1];
            console.log(`Extracted organization code from name: ${extractedCode}`);
            return formatOrganizationCode(extractedCode);
          }
        }
        
        // Check for roles that might indicate organization type
        if (response.data.roles && Array.isArray(response.data.roles)) {
          // Look for customer roles
          const hasCustomerRole = response.data.roles.some(role => 
            typeof role.authority === 'string' && 
            role.authority.toLowerCase().includes('customer'));
            
          if (hasCustomerRole) {
            console.log('User has customer role, using organization code: CST');
            return 'CST';
          }
          
          // Look for partner roles
          const hasPartnerRole = response.data.roles.some(role => 
            typeof role.authority === 'string' && 
            role.authority.toLowerCase().includes('partner'));
            
          if (hasPartnerRole) {
            console.log('User has partner role, using organization code: PTR');
            return 'PTR';
          }
          
          // Look for admin roles
          const hasAdminRole = response.data.roles.some(role => 
            typeof role.authority === 'string' && 
            role.authority.toLowerCase().includes('admin'));
            
          if (hasAdminRole) {
            console.log('User has admin role, using organization code: ORG');
            return 'ORG';
          }
        }
      }
    } catch (error) {
      console.error('Error fetching user profile for organization code:', error);
    }
    
    // If we got this far, we couldn't determine the org code
    console.log('Could not determine organization code from user context');
    return null;
  }; */

  // Function to get the current user's organization details from JWT token
  // Commented out as it's currently unused
  /*
  const fetchOrganizationDetails = async () => {
    try {
      // Get authentication token using the auth service
      const authToken = getToken();
      
      if (!authToken) {
        console.error('No authentication token available');
        setError('Authentication required. Please log in again.');
        return null;
      }
      
      console.log('Using auth token for organization details (first 20 chars):', authToken.substring(0, 20) + '...');

      // First check if there's a previously stored organization code
      const storedOrgCode = localStorage.getItem('organizationCode');
      if (storedOrgCode) {
        console.log('Using previously stored organization code:', storedOrgCode);
        setOrganizationCode(storedOrgCode);
        return storedOrgCode;
      }
      
      // Determine organization code based on user context
      const orgCode = await determineOrganizationCode(authToken);
      if (orgCode) {
        console.log('Determined organization code from user context:', orgCode);
        localStorage.setItem('organizationCode', orgCode);
        setOrganizationCode(orgCode);
        return orgCode;
      }
      
      // If we couldn't determine org code from user context, check token payload
      try {
        const tokenParts = authToken.split('.');
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          console.log('Extracted token payload:', payload);
          
          if (payload && payload.name) {
            console.log('User name from token:', payload.name);
            // Check if name contains organization information
            if (payload.name.toLowerCase().includes('customer')) {
              console.log('Name indicates customer organization, using CST');
              localStorage.setItem('organizationCode', 'CST');
              setOrganizationCode('CST');
              return 'CST';
            } else if (payload.name.toLowerCase().includes('partner')) {
              console.log('Name indicates partner organization, using PTR');
              localStorage.setItem('organizationCode', 'PTR');
              setOrganizationCode('PTR');
              return 'PTR';
            } else if (payload.name.toLowerCase().includes('admin')) {
              console.log('Name indicates admin organization, using ORG');
              localStorage.setItem('organizationCode', 'ORG');
              setOrganizationCode('ORG');
              return 'ORG';
            }
          }
        }
      } catch (tokenError) {
        console.error('Error parsing JWT token:', tokenError);
      }

      // If we couldn't determine the organization code, prompt the user
      console.log('Could not automatically determine organization code');
      const manualOrgCode = prompt('Please enter your organization code (e.g., ORG, CST, PTR, or a 3-digit code):', 'ORG');
      if (manualOrgCode) {
        // Format the manually entered code if it's numeric
        const formattedCode = formatOrganizationCode(manualOrgCode);
        console.log('Using manually entered organization code:', formattedCode);
        localStorage.setItem('organizationCode', formattedCode);
        setOrganizationCode(formattedCode);
        return formattedCode;
      }
      
      // If all else fails, return null and show error
      setError('Could not determine your organization code. Please try again.');
      return null;
    } catch (error) {
      console.error('Error fetching organization details:', error);
      return null;
    }
  };
  */

  // Helper to determine if the current token has an admin-level role
  const hasAdminRole = (token) => {
    if (!token) return false;
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return false;
      const payloadJson = JSON.parse(atob(parts[1]));
      const roles = payloadJson && payloadJson.roles ? payloadJson.roles : [];
      const roleStrings = Array.isArray(roles)
        ? roles.map(r => (typeof r === 'string' ? r : (r && r.authority) || '')).filter(Boolean)
        : [];
      const adminRoles = new Set([
        'ROLE_CUSTOMER_ADMIN',
        'ROLE_CUSTOMER_ORG_PRO',
        'ROLE_THAKLIS',
        'ROLE_ADMIN',
        'ROLE_ROOT_ADMIN',
      ]);
      return roleStrings.some(r => adminRoles.has(r));
    } catch (e) {
      console.error('Error parsing token for roles:', e);
      return false;
    }
  };

  // Function to fetch workflow requests using the appropriate endpoint
  const fetchRequests = async (orgCode) => {
    try {
      setLoading(true);
      setError('');
      setInfoMessage('');
      
      // Use the provided organization code or try to get it from localStorage
      const codeToUse = orgCode || localStorage.getItem('organizationCode');
      
      if (!codeToUse) {
        console.error('No organization code available');
        setError('No organization code available. Please log in again.');
        setLoading(false);
        return;
      }
      
      console.log('Using organization code for API call:', codeToUse);
      
      // Get authentication token using the auth service
      const authToken = getToken();
      
      if (!authToken) {
        console.error('No authentication token available');
        setError('Authentication required. Please log in again.');
        setLoading(false);
        return;
      }
      
      console.log('Using auth token (first 20 chars):', authToken.substring(0, 20) + '...');

      // Decide endpoint based on roles
      const isAdmin = hasAdminRole(authToken);
      const url = isAdmin
        ? `${API_PATHS.API}/workflow-requests/organization/code/${codeToUse}`
        : `${API_PATHS.V1}/workflow-requests/myRequests`;
      console.log('Workflow requests endpoint selected:', url);

      // Make API call to get workflow requests with proper authentication
      const response = await axios.get(url, {
        headers: { 
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
        timeout: 10000 // 10-second timeout
      });
      
      if (response && response.data) {
        console.log('Received workflow requests: ', response.data);
        const requestsWithDetails = response.data;
        console.log('Fetched requests with details requestsWithDetails:', requestsWithDetails);
        setRequests(requestsWithDetails);
        setInfoMessage(`Found ${requestsWithDetails.length} workflow requests`);
      } else {
        setRequests([]);
        setInfoMessage('No workflow requests found for your organization.');
      }
    } catch (error) {
      console.error('Error fetching workflow requests:', error);
      setError('Error fetching workflow requests. Please try again later.');
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      try {
        // Verify token validity first
        const authToken = getToken();
        if (!authToken) {
          console.error('No authentication token available');
          setError('Authentication required. Please log in again.');
          setLoading(false);
          return;
        }

        // Use the centralized function to get the organization code
        console.log('Getting organization code from auth service...');
        const orgCode = await getOrganizationCode();
        
        if (orgCode) {
          console.log('Retrieved organization code:', orgCode);
          setOrganizationCode(orgCode);
          await fetchRequests(orgCode);
        } else {
          setError('Could not determine your organization code. Please contact support.');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error initializing data:', error);
        setError('Error initializing data. Please try refreshing the page.');
        setLoading(false);
      }
    };
    
    initializeData();
  }, []);

  const handleNewRequest = () => {
    navigate('/CST-Workflow/new-request');
  };

  const handleMultiServiceGenerator = () => {
    navigate('/CST-Workflow/multi-service-generator');
  };

  const handleViewRequest = (requestId) => {
    navigate(`/CST-Workflow/requests/${requestId}/details`);
  };

  

  const filteredRequests = requests.filter(request => {
    // Target type filter
    if (targetTypeFilter !== 'ALL') {
      const reqTargetType = request.workflowTargetType || 'EMPLOYEE';
      if (reqTargetType !== targetTypeFilter) return false;
    }

    // Search filter
    const title = request.requestTitle || '';
    const workflow = request.workflowName || '';
    const status = request.status || '';
    const formattedId = getFormattedRequestId(request);

    return (
      title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      workflow.toLowerCase().includes(searchTerm.toLowerCase()) ||
      status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      formattedId.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <Box sx={{ p: 3 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      {infoMessage && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {infoMessage}
        </Alert>
      )}
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" component="h1">
          My Requests {organizationCode && `(Organization: ${organizationCode})`}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleMultiServiceGenerator}
          >
            Multi-Service Builder
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleNewRequest}
          >
            New Request
          </Button>
        </Box>
      </Box>

      <Paper sx={{ p: 2, mb: 3, bgcolor: '#e6f0f0' }}>
        <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
          <Chip
            label="All"
            color={targetTypeFilter === 'ALL' ? 'primary' : 'default'}
            onClick={() => setTargetTypeFilter('ALL')}
            variant={targetTypeFilter === 'ALL' ? 'filled' : 'outlined'}
          />
          <Chip
            label="Employee"
            color={targetTypeFilter === 'EMPLOYEE' ? 'primary' : 'default'}
            onClick={() => setTargetTypeFilter('EMPLOYEE')}
            variant={targetTypeFilter === 'EMPLOYEE' ? 'filled' : 'outlined'}
          />
          <Chip
            label="Organization"
            color={targetTypeFilter === 'ORGANIZATION' ? 'primary' : 'default'}
            onClick={() => setTargetTypeFilter('ORGANIZATION')}
            variant={targetTypeFilter === 'ORGANIZATION' ? 'filled' : 'outlined'}
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            placeholder="Search requests..."
            variant="outlined"
            size="small"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer sx={{ bgcolor: '#e6f0f0', borderRadius: '4px' }}>
            <Table>
              <TableHead sx={{ bgcolor: '#064d51' }}>
                <TableRow>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Request ID</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Customer Name</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Title</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Workflow</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Workflow Type</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Created Date</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Status</TableCell>
                  <TableCell>Progress</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 600 }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRequests.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No requests found.
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredRequests.map((request) => (
                    <TableRow key={request.id}>
                      <TableCell>
                        <Typography variant="body2">
                          {request.orgSequenceNumber || '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {request.customerName || '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {request.title || '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {request.workflowName || '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={request.workflowTargetType === 'ORGANIZATION' ? 'Organization' : 'Employee'}
                          size="small"
                          color={request.workflowTargetType === 'ORGANIZATION' ? 'secondary' : 'default'}
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ textAlign: 'center' }}>
                          {request.createdAt ? parseDate(request.createdAt).toLocaleDateString() : '-'}
                        </Typography>
                        <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary', fontSize: '0.75rem' }}>
                          {request.createdAt ? parseDate(request.createdAt).toLocaleTimeString() : ''}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <StatusChip status={request.workflowInstanceStatus || 'UNKNOWN'} />
                        </Box>
                      </TableCell>
                      <TableCell>
                        {request.workflowInstanceProgress !== undefined ? (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CircularProgress
                              variant="determinate"
                              value={request.workflowInstanceProgress}
                              size={24}
                              sx={{ mr: 1 }}
                            />
                            <Typography variant="body2">
                              {request.workflowInstanceProgress}%
                            </Typography>
                          </Box>
                        ) : '-'}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          color="primary"
                          onClick={() => handleViewRequest(request.id)}
                          title="View Request Details"
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
};

export default WorkflowRequestList;
